import withSpacing from '../../decorators/withSpacing/index';
import Tabs from './Tabs';
export default withSpacing(Tabs);
//# sourceMappingURL=index.js.map